export default __webpack_public_path__ + "static/catalog-554bc972587d853da2b7b0d6dd6d42c7.webp";